import english from './languages/english.json';
import VueI18n from "vue-i18n";
import Vue from 'vue';

Vue.use(VueI18n);

const defaultLocale = 'en'
const languages = {
    en: english
}
const messages = Object.assign(languages);
let i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: 'en',
    messages
})

const changeLocale = (langCode) => {
    i18n.locale = langCode
}

export {changeLocale}

export default i18n;